import React from "react";
import { Scientists } from "../../../lib/useScientists";
import { Cta } from "../../elements/Cta/Cta";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import * as styles from "./ScientistHero.module.css";
import { Link } from "../Link/Link";

interface Props extends Scientists {
  showCta: boolean;
  style: React.CSSProperties;
}

export const ScientistHero: React.FC<Props> = ({
  firstName,
  lastName,
  image,
  pageDescription,
  date,
  contentTile,
  showCta,
  page,
  style,
}) => {
  const scientistImage = image?.largeImage || contentTile?.image;
  const imageSize = scientistImage?.item?.size;

  const renderContainer = () => {
    return (
      <div className={styles.container}>
        {scientistImage && (
          <div className={styles.image}>
            <KontentImageElement
              image={scientistImage.item}
              height={582}
              width={534}
              options={{
                quality: imageSize && imageSize > 8000000 ? 25 : 75,
              }}
            />
            {scientistImage.caption && (
              <div className={styles.caption}>
                <CustomRichTextElement content={scientistImage.caption} />
              </div>
            )}
          </div>
        )}
        <div className={styles.content}>
          {contentTile?.contentCategory && (
            <div className={styles.contentCategory}>
              {contentTile?.contentCategory}
            </div>
          )}
          <h2>{firstName + " " + lastName || contentTile?.subhead}</h2>
          {date && <div className={styles.date}>{date.toUpperCase()}</div>}
          {contentTile?.text && contentTile?.text?.value !== "<p><br></p>" ? (
            <div className={styles.text}>
              <CustomRichTextElement content={contentTile?.text} />
            </div>
          ) : (
            <div className={styles.text}>
              <p>{pageDescription}</p>
            </div>
          )}
          {showCta && (contentTile?.ctaHref || page?.url) && (
            <div class={styles.ctaContainer}>
              <Cta
                href={contentTile?.ctaHref || page.url}
                ariaLabel={contentTile?.ctaAriaLabel}
                target={contentTile?.ctaTarget || "_self"}
                label={contentTile?.ctaLabel || "See Details"}
                button={false}
                invert
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.scientistHero} style={style}>
      {showCta && (contentTile?.ctaHref || page?.url) ? (
        <Link href={contentTile?.ctaHref || page.url} class={styles.clickable}>
          {renderContainer()}
        </Link>
      ) : (
        renderContainer()
      )}
    </div>
  );
};
